<!-- 根据券编码查询商家信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"couponSn":"5DWIJTB562OEE0Z64IE4"},
            responseCode: {
                "data": {
                    "address": "测试地址",
                    "codeType": 0,
                    "contact": "测试人",
                    "contactTel": "18575882521-1467709412282",
                    "limitNum": 0,
                    "limitType": 0,
                    "operateType": 0,
                    "operatorNum": 0,
                    "pic": "group1/M00/44/35/rBIoAVmdIcSAHuHEAAAhD8-Pt30293.jpg",
                    "traderName": "AKE测试商家",
                    "traderType": "美食"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据券编码查询商家信息",
                t_url: this.commonUrls.test+"queryTraderInfoByCouponCode",
                p_url: this.commonUrls.prod+"queryTraderInfoByCouponCode",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '发放券的唯一编号' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'traderCode', info2: '否', info3: 'String', info4: '商家编码' },
                        { info1: 'traderName', info2: '是', info3: 'String', info4: '商家名称' },
                        { info1: 'traderType', info2: '是', info3: 'String', info4: '商家类型' },
                        { info1: 'contact', info2: '是', info3: 'String', info4: '联系人' },
                        { info1: 'contactTel', info2: '是', info3: 'String', info4: '联系人电话' },
                        { info1: 'limitType', info2: '是', info3: 'Integer', info4: '限制购买类型。0无限制 1限制' },
                        { info1: 'limitNum', info2: '否', info3: 'Integer', info4: '限制购买数量。limitType=1是有效。' },
                        { info1: 'pic', info2: '否', info3: 'String', info4: '商家图片' },
                        { info1: 'operatorNum', info2: '否', info3: 'Integer', info4: '发放员数量' },
                        { info1: 'operateType', info2: '是', info3: 'Integer', info4: '发券方式。0商家发券 1中央发券' },
                        { info1: 'codeType', info2: '是', info3: 'Integer', info4: '是否支持固定二维码发券。0不支持 1支持' },
                        { info1: 'address', info2: '否', info3: 'String', info4: '地址' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '所属停车场' },
                        { info1: 'url', info2: '否', info3: 'String', info4: '商家链接' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryTraderInfoByCouponCode.vue